import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { BidSvg } from './BidSvg'

export const EaBidIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={BidSvg} {...props} />
)
